export default __webpack_public_path__ + "static/media/CafeAvion-6.9a323b1a.jpg";